module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-field form-field__bool",
    class: [_vm.rootClasses]
  }, [(_vm.label) ? _c('span', {
    staticClass: "form-field--title-label",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-field--row"
  }, _vm._l((_vm.uniqueItems), function(item, idx) {
    return _c('div', {
      staticClass: "form-field--input-container"
    }, [((_vm.type) === 'checkbox') ? _c('input', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.val),
        expression: "val"
      }],
      staticClass: "form-field--input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.val,
        "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, item.val) > -1 : (_vm.val)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.val,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.val,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.val = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.val = $$c
          }
        }, function($event) {
          _vm.updateValue()
        }]
      }
    }, 'input', _vm.getInputAttrs(item), false)) : ((_vm.type) === 'radio') ? _c('input', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.val),
        expression: "val"
      }],
      staticClass: "form-field--input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": item.val,
        "checked": _vm._q(_vm.val, item.val)
      },
      on: {
        "change": [function($event) {
          _vm.val = item.val
        }, function($event) {
          _vm.updateValue()
        }]
      }
    }, 'input', _vm.getInputAttrs(item), false)) : _c('input', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.val),
        expression: "val"
      }],
      staticClass: "form-field--input",
      attrs: {
        "type": _vm.type
      },
      domProps: {
        "value": item.val,
        "value": (_vm.val)
      },
      on: {
        "change": function($event) {
          _vm.updateValue()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.val = $event.target.value
        }
      }
    }, 'input', _vm.getInputAttrs(item), false)), _vm._v(" "), _c('label', {
      staticClass: "form-field--label-wrap",
      attrs: {
        "for": item.id
      }
    }, [_c('span', {
      staticClass: "form-field--box"
    }, [(_vm.type === 'radio') ? _c('span', {
      staticClass: "form-field--box-icon"
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'checkbox') ? _c('cmp-icon', {
      staticClass: "form-field--box-icon",
      attrs: {
        "symbol": "check",
        "size": "small"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "form-field--label",
      domProps: {
        "textContent": _vm._s(item.label || item.val)
      }
    })])])
  })), _vm._v(" "), _c('cmp-form-field-messages-partial', {
    attrs: {
      "messages": _vm.messages,
      "active-item": _vm.activeItem
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c506c20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c506c20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/form/form-field-bool/index.vue
// module id = 550
// module chunks = 7